/* eslint-disable jsx-a11y/label-has-associated-control */
import { ChangeEventHandler, ReactNode } from "react";
import clsx from "clsx";
import { CheckCircleIcon } from "@heroicons/react/20/solid";
import Label from "../Label";

interface IProps {
  id: string;
  label: string;
  isChecked?: boolean;
  labelClasses?: string;
  onChange: ChangeEventHandler;
  hintRender?: ReactNode;
}

const tabs = [{ name: "Airdrop" }, { name: "Incentive Drop" }];

function Knob({ labelClasses, label, id, isChecked = false, onChange, hintRender }: IProps) {
  return (
    <div>
      <div className="flex">
        <Label labelClasses={labelClasses} htmlFor={id} label={label} />
        {hintRender}
      </div>
      <label>
        <input type="checkbox" className="sr-only" checked={isChecked} onChange={onChange} />
        <div className="flex gap-1 overflow-clip rounded-ll border-1 border-white p-1.5">
          {tabs.map((tab, idx) => (
            <div
              key={tab.name}
              className={clsx(
                !!idx === isChecked
                  ? "bg-secondary text-primary"
                  : "bg-gray-200 bg-opacity-25 text-gray-500 hover:text-white",
                "group flex grow basis-0 cursor-pointer items-center rounded-ll py-2.5 pl-3 pr-2 text-xxs font-medium leading-snug transition-all duration-300 active:bg-gray-50 active:bg-opacity-10",
              )}
            >
              {isChecked === !!idx ? (
                <CheckCircleIcon className="-ml-2 mr-1 h-4 w-5 text-primary opacity-90" />
              ) : (
                <div className="-ml-1 mr-2 h-2.5 w-2.5 rounded-full bg-white bg-opacity-25 opacity-90 transition-all duration-300 group-hover:bg-opacity-80" />
              )}
              <p>{tab.name}</p>
            </div>
          ))}
        </div>
      </label>
    </div>
  );
}

export default Knob;
